import { Grid } from '@mui/material'
import Image from 'next/image'

const RegistrationTitle = () => {
  return (
    <Grid container justifyContent={'center'}>
      <Grid item mr={3}>
        <Image src='/u-miru_logo.svg' width={96} height={32} alt='u-miru_logo' />
      </Grid>
      <Grid item>
        <Image src='/chikamichi_logo.svg' width={105} height={32} alt='chikamichi_logo' />
      </Grid>
    </Grid>
  )
}

export default RegistrationTitle
